import Block from '../block'

export default class Popup extends Block {
	static title = 'popup'

	init() {
		this.overlay = document.querySelector('.overlay--main')

		this.closeButton = this.getElement('close')
		if (this.closeButton) {
			this.closeButton.addEventListener('click', () => this.close())
		}

		if (this.overlay) {
			this.overlay.addEventListener('click', () => this.close())
		}
	}

	toggle() {
		if (this.hasModifier('hidden') || !this.hasModifier('active')) {
			this.open()
			return
		}
		this.close()
	}

	open() {
		this.removeModifier('hidden')
		this.addModifier('active')
		this.eventEmitter.emit('popup:open')
	}

	close() {
		this.addModifier('hidden')
		this.removeModifier('active')
		this.eventEmitter.emit('popup:close')
	}
}
